import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { team } from "../data/team";
import { businessInfo } from "../mock";

// Compact E-E-A-T reviewer byline for substantive claim/service pages.
// Uses only real Claim Beast personnel/credentials already on the site.
// Update LAST_REVIEWED when content is refreshed.
const LAST_REVIEWED = "June 2026";

const ReviewedBy = ({ reviewer = "Joe", lastReviewed = LAST_REVIEWED }) => {
  const member =
    team.find((m) => m.name.toLowerCase() === String(reviewer).toLowerCase()) ||
    team[0];
  const flLicense = member.licenses?.florida || businessInfo.licenses.florida;

  return (
    <div
      className="max-w-4xl mx-auto px-4 sm:px-6 py-6"
      data-testid="reviewed-by-byline"
    >
      <div className="flex items-center gap-4 bg-[#0F0F0F] border border-white/10 p-4">
        <img
          src={member.photo}
          alt={`${member.name}, ${member.role} at Claim Beast Public Adjusters`}
          className="h-12 w-12 object-cover grayscale shrink-0"
        />
        <div className="text-sm">
          <div className="flex items-center gap-1.5 text-[#E11D26] text-[11px] font-bold tracking-[0.2em] uppercase">
            <BadgeCheck className="h-3.5 w-3.5" /> Reviewed by a Licensed Public Adjuster
          </div>
          <p className="mt-1 text-white/80">
            <Link
              to={`/about#${member.slug}`}
              className="text-white font-bold hover:text-[#E11D26] transition-colors"
            >
              {member.name}
            </Link>{" "}
            <span className="text-white/60">
              · {member.role} · FL License {flLicense}
            </span>
          </p>
          <p className="mt-0.5 text-white/45 text-xs">Last reviewed: {lastReviewed}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewedBy;
